import React, { createContext, useContext, useMemo, useState } from 'react';

const PolicyMakerNavContext = createContext(null);

export function PolicyMakerNavProvider({ children }) {
  const [workspaceNav, setWorkspaceNav] = useState(null);

  const value = useMemo(
    () => ({
      workspaceNav,
      setWorkspaceNav,
    }),
    [workspaceNav],
  );

  return (
    <PolicyMakerNavContext.Provider value={value}>{children}</PolicyMakerNavContext.Provider>
  );
}

export function usePolicyMakerNav() {
  return useContext(PolicyMakerNavContext);
}
